import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import HomePage from './pages/HomePage/HomePage';
import AboutPage from './pages/AboutPage/AboutPage';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import MenuPage from './pages/MenuPage/MenuPage';
import EventPage from './pages/EventPage/EventPage';
import GalleryPage from './pages/GalleryPage/GalleryPage';
import CareerPage from './pages/CareerPage/CareerPage';
import ContactPage from './pages/ContactPage/ContactPage';
import ReservationPage from './pages/ReservationPage/ReservationPage';

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: location.pathname });
  }, [location]);

  return null;
};

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <PageTracker />
      <Navbar />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/events" element={<EventPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/career" element={<CareerPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/reservation" element={<ReservationPage />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
};

export default App;